export const DEFAULT_INSPECTOR_CONTEXT = 'quality_inspector';

export const INSPECTOR_CONTEXTS = [
  { id: 'quality_inspector', label: 'Quality Inspector' },
  { id: 'metal_work_inspector', label: 'Metal Work Inspector' },
  { id: 'rust_inspector', label: 'Rust Inspector' },
  { id: 'road_view_inspector', label: 'Road View Inspector' },
  { id: 'healthcare_inspector', label: 'Healthcare Inspector' },
];

const inspectorContextIds = new Set(INSPECTOR_CONTEXTS.map(item => item.id));

export function normalizeInspectorContext(
  value,
  fallback = DEFAULT_INSPECTOR_CONTEXT,
) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  return inspectorContextIds.has(normalized) ? normalized : fallback;
}

export function inspectorContextLabel(value, fallback = 'Use job context') {
  return (
    INSPECTOR_CONTEXTS.find(
      item => item.id === normalizeInspectorContext(value, null),
    )?.label || fallback
  );
}
